/*eslint complexity: off*/
import React, {
  useState
} from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import moment from 'moment';
import Send from '@material-ui/icons/Send';
import Input from '@material-ui/core/Input';

import Paper from '~/components/Paper';
import Filter from '~/containers/Filter';
import Button from '~/components/Button';
import InputControl from '~/components/Input/InputControl';
import InputDate from '~/components/Input/InputDate';
import InputDropzone from '~/components/Input/InputDropzone';
import Form from '~/containers/Form';
import GridContainer from '~/components/GridContainer';
import GridItem from '~/components/GridItem';
import useStyles from './styles';
import userColumns from '~/config/customQuery/userConfig';
import PushRecord from '~/records/PushRecord';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';

const attrName = (attr) => PushRecord.hummanAttributeName(attr);

function PushItem({ record, handleChange, onSubmit, loading, setRecord }) {
  const classesRoot = useStyles();
  const [open, setOpen] = useState(false);
  const { t } = useTranslation();
  const isPersisted = record.isPersisted();
  const [language, setLanguage] = useState('pt');
  const languageObject = {
    pt: '',
    en: '_en',
    es: '_es',
  };

  const handleRadio = event => setLanguage(event.target.value);

  const sendAlready = moment().isAfter(record.get('send_at')) &&
    moment().isSame(record.get('send_at'));

  return (
    <>
      <Form onSubmit={onSubmit} >
        <Paper
          Icon={Send}
          iconColor={isPersisted ? 'purple' : 'blue'}
          title={t('push.defSingular')}
          loading={loading}
        >
          <div className={clsx(classesRoot.root)}>
            <GridContainer>
              <GridItem xs={12} md={12}>
                <RadioGroup aria-label="position" name="position" value={language} onChange={handleRadio} row>
                  <FormControlLabel
                    value="pt"
                    control={<Radio color="primary" />}
                    label="PT-BR"
                    labelPlacement="end"
                  />
                  <FormControlLabel
                    value="en"
                    control={<Radio color="primary" />}
                    label="EN"
                    labelPlacement="end"
                  />
                  <FormControlLabel
                    value="es"
                    control={<Radio color="primary" />}
                    label="ES"
                    labelPlacement="end"
                  />
                </RadioGroup>
              </GridItem>
              <GridItem xs={8} md={4}>
                <InputControl
                  name={`title${languageObject[language]}`}
                  value={record.get(`title${languageObject[language]}`)}
                  required={true}
                  label={attrName(`title${languageObject[language]}`)}
                  inputComponent={Input}
                  onChange={handleChange}
                />
              </GridItem>
              <GridItem xs={8} sm={10} md={4}>
                <InputControl
                  value={record.get(`subtitle${languageObject[language]}`)}
                  name={`subtitle${languageObject[language]}`}
                  label={attrName(`subtitle${languageObject[language]}`)}
                  inputComponent={Input}
                  onChange={handleChange}
                />
              </GridItem>
              <GridItem xs={8} sm={10} md={3}>
                <InputControl
                  value={moment(record.get('send_at')).format()}
                  name="send_at"
                  disabled={loading || sendAlready}
                  required={true}
                  label={attrName('send_at')}
                  inputComponent={InputDate}
                  InputProps={{
                    type: 'datetime',
                    minDate: moment(),
                    isNotEdit: sendAlready
                  }}
                  //CUSTOM HANDLE CHANGE
                  onChange={(date) => setRecord(record.updateAttributes({ send_at: moment(date).format() }))}
                />
              </GridItem>
              <GridItem xs={12} sm={9}>
                <InputControl
                  value={record.get(`message${languageObject[language]}`)}
                  name={`message${languageObject[language]}`}
                  required={true}
                  label={attrName(`message${languageObject[language]}`)}
                  inputComponent={Input}
                  InputProps={{
                    multiline: true,
                    rows: '4',
                  }}
                  onChange={handleChange}
                />
              </GridItem>
              <GridItem xs={12} sm={3}>
                {!(sendAlready) &&
                  <Button onClick={() => setOpen(true)}>
                    Filtros
                </Button>
                }
              </GridItem>
              <GridItem xs={12} sm={6}>
                <InputControl
                  value={record.get('link_url')}
                  name="link_url"
                  disabled={loading || sendAlready}
                  label={attrName('link_url')}
                  inputComponent={Input}
                  onChange={handleChange}
                />
              </GridItem>
              <GridItem xs={12} sm={6}>
                <InputControl
                  value={record.get('image_url')}
                  name="image_url"
                  disabled={loading || sendAlready}
                  label={attrName('image_url')}
                  inputComponent={Input}
                  onChange={handleChange}
                />
              </GridItem>
              <GridItem xs={12}>
                <Filter
                  filter={record.get('filter')}
                  open={open}
                  onCancel={() => {
                    setOpen(false);
                  }}
                  onFilter={(compress) => {
                    setRecord(record.updateAttributes({ filter: compress }));
                    setOpen(false);
                  }}
                  columns={userColumns(t).map(col => ({
                    ...col,
                    type: col.lookup ? 'options' : col.type,
                  }))}
                />
              </GridItem>
              <GridItem xs={8} sm={10} md={8}>
                <InputControl
                  value={record.get('image_base64')}
                  name="image_base64"
                  disabled={loading || sendAlready}
                  label={attrName('image_base64')}
                  inputComponent={InputDropzone}
                  InputProps={{
                    image: record.get('image'),
                    sendAlready: sendAlready
                  }}
                  onChange={handleChange}
                />
              </GridItem>
            </GridContainer>
          </div>
        </Paper>
      </Form>
    </>
  );
}

PushItem.propTypes = {
  record: PropTypes.instanceOf(PushRecord).isRequired,
  handleChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  setRecord: PropTypes.func.isRequired,
};

PushItem.defaultProps = {
  loading: false,
};

export default React.memo(withRouter(PushItem));
